import {
  AppStatePartialState,
  APP_STATE_FEATURE_KEY,
} from './app-state.reducer';

type Action = {
  type: '[UtilState] Add User Details' | '[UtilState] App on Logout' | '[AppState/CONFIG] Add Config' | '';
  userData?: { id: string; user: any };
  configurations: any
};

const _handleState = (
  state: AppStatePartialState,
  action: Action
): AppStatePartialState => {
  switch (action.type) {
    case '[UtilState] Add User Details':
      console.log('[UtilState] Add User Details line~21 appstate');
      return {
        ...state,
        [APP_STATE_FEATURE_KEY]: {
          ...state[APP_STATE_FEATURE_KEY],
          token: action.userData.id,
          userData: action.userData.user,
        },
      };
    case '[UtilState] App on Logout':
      return {
        ...state,
        [APP_STATE_FEATURE_KEY]: {
          ...state[APP_STATE_FEATURE_KEY],
          token: null,
          userData: {},
        },
      };
    case '[AppState/CONFIG] Add Config':
      return {
        ...state,
        appState: {
          ...state.appState,
          configurations: action.configurations,
        },
      };
    default:
      return state;
  }
};

export const updateRootState = (reducer) => (state, action) =>
  reducer(_handleState(state, action), action);

// action -> utils
// action fire -> login (utils)
// action listn -> appstate
